import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-modal-rename-confirm',
  standalone: true,
  imports: [FormsModule, FontAwesomeModule, TranslateModule, ButtonComponent],
  templateUrl: './modal-rename-confirm.component.html',
  styleUrls: ['./modal-rename-confirm.component.scss']
})
export class ModalRenameConfirmComponent {
  @Input() show = false;
  @Input() loading = false;
  @Input() itemName = '';
  @Input() initialValue = '';

  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<string>();

  faPen = faPen;
  faTimes = faTimes;

  value = '';

  ngOnChanges(): void {
    this.value = this.initialValue || this.itemName || '';
  }

  onClose(): void {
    if (this.loading) {
      return;
    }
    this.close.emit();
  }

  onConfirm(): void {
    const trimmedValue = this.value.trim();
    if (!trimmedValue || this.loading) {
      return;
    }
    this.confirm.emit(trimmedValue);
  }
}
